// digitt: DENG-7201 — a label's `color` field stores either a hex color or an emoji.
// Hex colors always start with "#"; anything else is treated as an emoji marker.
export const isHexColor = (value = '') =>
  typeof value === 'string' && value.startsWith('#');

export const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i += 1) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};
